// extracted by mini-css-extract-plugin
module.exports = {"root":"PlatformFooterNavigationLayout_root__nCij1","isContextualLinks":"PlatformFooterNavigationLayout_isContextualLinks__08cuj"};